import axiosInstance from '../axiosInstance';

export const fetchTiposServicios = async () => {
  const response = await axiosInstance.get('/administration/service-types');
  return response.data;
};

export const createTipoServicio = async (data) => {
  const response = await axiosInstance.post('/administration/service-types', data);
  return response.data;
};

export const updateTipoServicio = async (id, data) => {
  const response = await axiosInstance.put(`/administration/service-types/${id}`, data);
  return response.data;
};

export const deleteTipoServicio = async (id) => {
  const response = await axiosInstance.delete(`/administration/service-types/${id}`);
  return response.data;
};